import service from "@/utils/request";

/**
 * TCL 扫码收货 - 按入库单号查询待收货列表
 * GET /uic-system/warein/page?inType=0|1&source=0&wareInStatus=0&wareInNo=xxx
 * inType: 0=收货入库，1=退货入库
 */
export function getTclWareInPage(params) {
  return service.get("/uic-system/warein/page", {
    params: {
      inType: params?.inType ?? 0,
      source: params?.source ?? 0,
      wareInStatus: params?.wareInStatus ?? 0,
      wareInNo: params?.wareInNo || "",
      current: params?.current || 1,
      size: params?.size || 20,
    },
  });
}

/**
 * TCL 扫码收货 - 入库单详情（含明细与箱码）
 * GET /uic-system/api_hf/warein/detail?id=xxx
 */
export function getTclWareInDetail(id) {
  return service.get("/uic-system/api_hf/warein/detail", {
    params: { id },
  });
}

/**
 * TCL 扫码收货 - 校验箱码是否已入库
 * GET /uic-system_hf/materialstockdetail/stockWareDetail/checkBarCodeWareIn
 * @param {string|number} materialId
 * @param {string} barCode
 * @returns {Promise} data 为 Long：0=未入库可扫，>0=已入库不可扫
 */
export function checkBarCodeWareIn(materialId, barCode) {
  return service.get(
    "/uic-system_hf/materialstockdetail/stockWareDetail/checkBarCodeWareIn",
    {
      params: {
        materialId,
        barCode,
      },
    }
  );
}

/**
 * TCL 扫码收货 - 确认入库
 * POST /uic-system_hf/warein/tclScanSubmitV2
 * 入参示例：
 * {
 *   id,
 *   wareInDetailList: [
 *     { materialId, boxList: [{ barCode, wareOutNum }] }
 *   ]
 * }
 */
export function tclWareInCollect(data) {
  return service.post("/uic-system_hf/warein/tclScanSubmitV2", data);
}
